import { Button, Typography } from 'components'
import { Icons, MoveOverProps, TypographyTypes } from 'interfaces'
import React from 'react'

export const MoveOver: React.FC<MoveOverProps> = ({
	url,
	setOpen,
	setQrCode,
	handleCopy
}) => {
	return (
		<div className="mt-6">
			<Typography
				className="mb-1"
				fontLeading="15/15"
				type={TypographyTypes.h3}
				title="Login to New Version"
			/>
			<Typography
				fontLeading="12/15"
				type={TypographyTypes.p}
				className="text-gray-1 !font-normal"
				title="Copy & paste your Move Over Link where people can click. Post QR Code where they can scan it."
			/>

			<div className="flex justify-between w-full bg-blue-primary/[0.08] rounded-lg break-all items-center py-0.5 mt-3">
				<Typography
					fontLeading="12/15"
					title={url as string}
					type={TypographyTypes.p}
					className="p-2 !font-normal text-blue-primary truncate"
				/>
				<Button
					onClick={handleCopy}
					iconLeft={Icons.copy}
					color="BlueTransparent"
					className="!min-w-[unset] !border-none"
				/>
			</div>

			<div className="flex items-center justify-end gap-2 mt-7">
				<Button
					label="QR Code"
					iconLeft={Icons.qrCode}
					className="!min-w-[unset] !py-[9px]"
					onClick={() => {
						setOpen(true)
						setQrCode(url as string)
					}}
				/>
			</div>
		</div>
	)
}
